<template>
  <div>
    <Filtro
      @clientesRuraisFiltrados="atualizarFiltro"
      :redirectToCadastroEdicao="redirectToCadastroEdicao"
    />
    <div class="card mt-3">
      <div class="card-body position-relative">
        <div v-if="loadingTabela" class="overlay-spinner">
          <b-spinner class="ms-2" variant="primary"></b-spinner>
        </div>

        <Grid
          :items="items"
          :filtro="filtro"
          @editarItem="editarItem"
          :default-mensagem="mensagemGrid"
          @clientesRuraisFiltrados="atualizarFiltro"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Filtro from "@/components/astec/filtro";
import Grid from "@/components/astec/gridClienteRural";
import clienteRuralMixin from "@/tools/mixins/clienteRuralMixin.js";

export default {
  mixins: [clienteRuralMixin],
  components: {
    Filtro,
    Grid,
  },
  data() {
    return {
      filtro: {},
      items: [],
      loadingTabela: false,
      mensagemGrid: "Nenhum cliente rural encontrado.",
    };
  },

  created() {
    this.$tools.fecharMenu();
  },

  methods: {
    redirectToCadastroEdicao() {
      this.$store.commit("CLIENTE_RURAL_ASTEC", "");
      this.$router.push({ path: "clienteRural/cadastroEdicao/" });
    },

    async atualizarFiltro(novoFiltro, callback) {
      if (!novoFiltro || Object.keys(novoFiltro).length === 0) {
        this.filtro = {};
        this.items = [];
        this.loadingTabela = false;

        this.$store.commit("PARAMETROS_FILTRO_CLIENTE_RURAL_ASTEC", null);
        if (typeof callback === "function") callback();
        return;
      }

      this.filtro = novoFiltro;
      await this.buscarItens(novoFiltro);

      if (typeof callback === "function") callback();
    },

    async editarItem(item) {
      this.$store.commit("CLIENTE_RURAL_ASTEC", item);
      this.$router.push({ path: "clienteRural/cadastroEdicao/" });
    },

    async buscarItens(filtro) {
      this.loadingTabela = true;
      try {
        const response = await this.$http.post("/api/astec/getClienteRuralLista", filtro);
        this.items = response.data;
      } catch (err) {
        this.$tools.alerta(err.response?.data?.message || "Erro desconhecido", "error");
      } finally {
        this.loadingTabela = false;
      }
    },
  },
};
</script>

<style>
.sortable-header {
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.sort-icon {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-left: 5px;
}

.overlay-spinner {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 10;
}
</style>
